import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    globalHeaderDashboard: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLightest ||
            '#F0F0F0',
        overflowY: 'auto' as const,
        height: theme?.app?.clientTheme.layoutSettings.useGlobalHeader ? 'calc(100vh - 65px)' : '100%'
    },
    dashboardFooter: {
        padding: '0 20px .5rem 20px',
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        height: '100%'
    },
    footerLogoContainer: { width: 'fit-content' },
    footerLogo: {
        height: '22px',
        margin: '0 8px'
    },
    tzeroInfoIconContainer: {
        height: '18px',
        alignSelf: 'center' as const
    },
    tzeroInfoIcon: {
        alignSelf: 'center' as const,
        cursor: 'pointer' as const,
        height: '18px',
        width: '18px'
    },
    tassatpayLogo: { height: '33px' }
});